import { LucideProps } from 'lucide-react'
import { Tooltip } from 'react-tooltip'
import Button from '../Button'
import useUserPermissions from '@/common/hooks/useUserPermissions'

interface CopyButtonProps extends LucideProps {
  control: {
    tooltipId: string
    icon: React.ComponentType<LucideProps>
    message: string
  }
  operationKlassToCheckPermission?: string
}

export const CopyButton = ({ control: { tooltipId, icon: Icon, message }, operationKlassToCheckPermission, ...props }: CopyButtonProps) => {
  const { hasUserPermission, isUserPermissionsPending } = useUserPermissions();

  const isPermissionNeeded = !!operationKlassToCheckPermission;
  const hasPermission = isPermissionNeeded && hasUserPermission(operationKlassToCheckPermission);

  return (
    <>
      <Button
        tooltipPlace='right'
        variant="link-white"
        disabled={isPermissionNeeded && !hasPermission}
        isLoading={isUserPermissionsPending}
      >
        <Icon data-tooltip-id={tooltipId} strokeWidth={1.5} {...props} />
      </Button>

      <Tooltip id={tooltipId} className='z-50'>
        {isPermissionNeeded && !hasPermission ? 'Você não tem permissão' : message}
      </Tooltip>
    </>
  );
}
